import { render, staticRenderFns } from "./headTItle.vue?vue&type=template&id=0cb70b63"
import script from "./headTItle.vue?vue&type=script&lang=js"
export * from "./headTItle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports